import React from "react";

import {Layout} from "antd";

import {Header} from "./components/header/Header";
import {LandingPage} from "./pages/LandingPage";

import "antd/dist/antd.css";
import "./index.less";

const {Content} = Layout;

function App() {
	return (
		<Layout style={{minHeight: "100vh"}}>
			<Header />
			<Content
				style={{
					width: "100%",
					padding: 10,
					margin: "auto",
					backgroundColor: "rgba(162,199,226, 0.05)",
				}}>
				<LandingPage />
			</Content>
		</Layout>
	);
}

export default App;
